<template>
  <div class="box-wrapper flex">
    <div class="container flex-column" id="content">
      <div class="card card-type2">
        <div class="card-contents-button-wrapper">
          <div class="flex-spacebetween-aligncenter">
            <div class="category" v-show="classificationFullName != ''">
              <span>분류</span>
              <span>|</span>
              <span>{{ classificationFullName }}</span>
            </div>
          </div>
          <div class="card-contents">
            <div class="card-contents-box" style="margin-right: 10px">
              <h1>{{ mainTitle }}</h1>
              <div class="category">
                <span>{{ navigationTitle }}</span>
              </div>
              <br />
              <div class="hashtag-wrapper">
                <button
                  type="button"
                  class="btn hashtag"
                  v-for="item in detailInfo['classifications']"
                  :key="item.anlClsNo"
                >
                  #{{ item.anlClsNm }}
                </button>
              </div>
            </div>
            <div class="button-wrapper flex-column" style="min-width: 200px">
              <button
                type="button"
                class="btn border icon down"
                @click="onFileDownload"
              >
                원본 보고서 다운로드
              </button>
              <button
                type="button"
                class="btn border icon down-purple"
                @click="onPdfFileDownload"
                v-show="isShowSection"
                style="color: #9a87f5; border: 1px solid #9a87f5"
              >
                부분 보고서 다운로드
              </button>
            </div>
          </div>
          <div class="research-wrapper-box flex">
            <!-- <div class="research-wrapper flex-column">
              <div class="researcher">
                <span>연구책임자</span>
                <span>|</span>
                <span>{{ this.detailMasterInfo.rptAuthNm }}</span>
                <span></span>
              </div>
              <div class="researcher" :hidden="true">
                <span>공 동 연 구</span>
                <span>|</span>
                <span>김향자</span>
                <span>(서울 시립대학교 도시사회학과 초빙교수)</span>
              </div>
            </div> -->
            <div class="research-wrapper flex-column">
              <div class="researcher">
                <span>발 간 년 도</span>
                <span>|</span>
                <span>{{ this.detailMasterInfo.rptPubYear }}년</span>
                <span></span>
              </div>
            </div>
            <!-- <div class="research-wrapper flex-column">
              <div class="researcher">
                <span>보고서유형</span>
                <span>|</span>
                <span>{{ this.detailMasterInfo.rptPubType }}</span>
                <span></span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="main-text-wrapper">
        <h3 style="display: none">본문내용</h3>
        <hr style="display: none" />
        <!--        <h3 v-show="this.detailInfo.chapterNm != null" >{{ this.detailInfo.chapterNm }}</h3>-->
        <!--        <h4 v-show="this.detailInfo.sessionNm != null" >{{ this.detailInfo.sessionNm }}</h4>-->
        <!--        <h5 v-show="this.detailInfo.indexNm != null" >{{ this.detailInfo.indexNm }}</h5>-->

        <h3>{{ this.descTitle }}</h3>
        <div class="text-wrapper">
          <!--          <p v-html="reportDesc"></p>-->
          <vue-pdf-app
            style="height: 80vh"
            page-scale="page-fit"
            :pdf="pdfData"
            :config="pdfConfig"
            :page="1"
          ></vue-pdf-app>
        </div>
      </div>
      <div class="button-right">
        <button type="button" class="btn list-go" @click="onBack">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            aria-label="목록으로"
          >
            <path
              d="M104 112C90.7 112 80 122.7 80 136L80 184C80 197.3 90.7 208 104 208L152 208C165.3 208 176 197.3 176 184L176 136C176 122.7 165.3 112 152 112L104 112zM256 128C238.3 128 224 142.3 224 160C224 177.7 238.3 192 256 192L544 192C561.7 192 576 177.7 576 160C576 142.3 561.7 128 544 128L256 128zM256 288C238.3 288 224 302.3 224 320C224 337.7 238.3 352 256 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L256 288zM256 448C238.3 448 224 462.3 224 480C224 497.7 238.3 512 256 512L544 512C561.7 512 576 497.7 576 480C576 462.3 561.7 448 544 448L256 448zM80 296L80 344C80 357.3 90.7 368 104 368L152 368C165.3 368 176 357.3 176 344L176 296C176 282.7 165.3 272 152 272L104 272C90.7 272 80 282.7 80 296zM104 432C90.7 432 80 442.7 80 456L80 504C80 517.3 90.7 528 104 528L152 528C165.3 528 176 517.3 176 504L176 456C176 442.7 165.3 432 152 432L104 432z"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  fetchSearchReportDetail,
  fileDownload,
  fileLoad,
  fileLinkUrl,
  pdfFileDownload,
} from "@/api/StatReportSearch.js";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";

export default {
  name: "SearchDetail",
  components: {
    VuePdfApp,
  },
  props: {
    anlDetailNo: {
      type: Number,
      required: true,
    },
    selectedTarget: {
      type: String,
      default: "",
    },
    selectedSubject: {
      type: String,
      default: "",
    },
  },
  computed: {
    mainTitle: function () {
      let title = "";
      switch (this.detailInfo["rstContentsType"]) {
        case "I":
          title = this.detailInfo["indexNm"];
          break;
        case "S":
          title = this.detailInfo["sessionNm"];
          break;
        case "C":
          title = this.detailInfo["chapterNm"];
          break;
      }
      return title;
    },
    navigationTitle: function () {
      let title = "";
      switch (this.detailInfo["rstContentsType"]) {
        case "I":
          title =
            this.detailMasterInfo.anlMstNm +
            " > " +
            this.detailInfo["chapterNm"] +
            " > " +
            this.detailInfo["sessionNm"] +
            " > " +
            this.detailInfo["indexNm"];
          break;
        case "S":
          title =
            this.detailMasterInfo.anlMstNm +
            " > " +
            this.detailInfo["chapterNm"] +
            " > " +
            this.detailInfo["sessionNm"];
          break;
        case "C":
          title =
            this.detailMasterInfo.anlMstNm +
            " > " +
            this.detailInfo["chapterNm"];
          break;
      }
      return title;
    },
    descTitle: function () {
      let title = "";
      switch (this.detailInfo["rstContentsType"]) {
        case "I":
          title =
            this.detailInfo["chapterNm"] +
            " > " +
            this.detailInfo["sessionNm"] +
            " > " +
            this.detailInfo["indexNm"];
          break;
        case "S":
          title =
            this.detailInfo["chapterNm"] + " > " + this.detailInfo["sessionNm"];
          break;
        case "C":
          title = this.detailInfo["chapterNm"];
          break;
      }
      return title;
    },

    isShowSection: function () {
      if (this.detailInfo["rstContentsType"] === "I") {
        if (this.detailParentInfo !== null) {
          return true;
        }
      }

      if (this.detailInfo["rstContentsType"] === "S") {
        return true;
      }
      return false;
    },
    classificationFullName: function () {
      let title = "";
      if (this.detailInfo["classifications"]) {
        for (const classData of this.detailInfo["classifications"]) {
          if (classData.anlClsNm === this.selectedSubject) {
            title = this.selectedTarget + " > " + this.selectedSubject;
          }
        }
      }
      return title;
    },
    reportDesc: function () {
      if (this.detailInfo) {
        if (this.detailInfo["summaryDesc"]) {
          return this.detailInfo["summaryDesc"].replace(/\n/gi, "<br/>");
        }
      }
      return this.detailInfo["summaryDesc"];
    },
  },
  data() {
    return {
      detailInfo: {},
      detailMasterInfo: {},
      detailParentInfo: {},
      pdfData: null,
      pdfConfig: {
        toolbar: {
          toolbarViewerLeft: {
            previous: true,
          },
          toolbarViewerRight: {
            openFile: false,
            viewBookmark: false,
          },
        },
      },
    };
  },
  created() {
    this.searchReportDetail();
  },
  mounted(){
    window.scrollTo(0,0)
  },

  methods: {
    goMenu(pageIdx) {
      if (pageIdx !== 0) {
        this.$router.push({
          name: "Main",
          params: {
            pageIndex: pageIdx,
          },
        });
      }
    },

    searchReportDetail() {
      fetchSearchReportDetail({ anlDetailNo: this.anlDetailNo }).then(
        (response) => {
          if (response.data) {
            this.detailInfo = response.data;
            this.detailMasterInfo = this.detailInfo["masterReport"];
            this.detailParentInfo = this.detailInfo["parentReport"];

            if (
              this.detailInfo["rstContentsType"] === "S" ||
              this.detailInfo["rstContentsType"] === "I"
            ) {
              let fileId = "";

              // if (this.detailParentInfo === null) {
              fileId = this.detailInfo["rstFileId"];
              // } else {
              //   fileId = this.detailParentInfo['rstFileId']
              // }

              this.pdfData = fileLinkUrl(fileId);
            }
          }
        }
      );
    },

    onFileDownload() {
      fileDownload(
        this.detailMasterInfo.anlFileId,
        this.detailMasterInfo.anlMstNm + ".pdf"
      );
    },

    onPdfFileDownload() {
      let fileName = "";
      switch (this.detailInfo["rstContentsType"]) {
        case "I":
          fileName =
            this.detailMasterInfo.anlMstNm +
            "_" +
            this.detailInfo["chapterNm"] +
            "_" +
            this.detailInfo["sessionNm"] +
            "_" +
            this.detailInfo["indexNm"];
          break;
        case "S":
          fileName =
            this.detailMasterInfo.anlMstNm +
            "_" +
            this.detailInfo["chapterNm"] +
            "_" +
            this.detailInfo["sessionNm"];
          break;
        default:
          fileName =
            this.detailMasterInfo.anlMstNm + "_" + this.detailInfo["chapterNm"];
      }
      pdfFileDownload(this.detailInfo["rstFileId"], fileName + ".pdf");
    },

    onFileLoad() {
      fileLoad(
        this.detailMasterInfo.anlFileId,
        this.detailMasterInfo["anlFileNm"]
      );
    },

    onBack() {
      let searchModel = this.$route.params.searchModel;

      this.$router.push({
        name: "통계 보고서",
        params: {
          searchModel: searchModel,
        },
      });
    },
  },
};
</script>

<style scoped>
.list-go {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  box-shadow: 3px 5px 15px #e7e0e0;
  padding: 10px;
  background-color: #fff;
}
.button-right {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  z-index: 100;
  padding: 0 10px;
}
.box-wrapper {
  width: 100%;
  margin-top: 106px;
}
hr {
  margin: 0;
}
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 44px 0 200px;
  gap: 23px;
}
.box-wrapper::before {
  content: "";
  width: 100%;
  height: 276px;
  background-color: #f9f9f9;
  position: absolute;
  border-bottom: 2px solid #d7d7d7;
}
.card-type2 {
  width: 1200px;
}

.main-text-wrapper {
  width: 100%;
  min-height: 534px;
  /* border: 1px solid #dadee8;
    border-radius: 15px; */
  padding: 44px 0;
  position: relative;
  z-index: 1;
  @media screen and (max-width: 768px) {
    padding: 44px 10px;
  }
}

.main-text-wrapper h3 {
  font-weight: 600;
  font-size: 22px;
  letter-spacing: 0.5px;
  display: flex;
  gap: 17px;
}

.main-text-wrapper h3:first-child {
  font-weight: 700;
  font-size: 22px;
  color: #9a87f5;
}

.main-text-wrapper h3:nth-of-type(2)::before {
  content: "";
  background-image: url("../../assets/img/main-text-before.png");
  background-repeat: no-repeat;
  background-size: contain;
  width: 23px;
  height: 26px;
  display: inline-block;
  transform: translateY(5px);
}

.main-text-wrapper hr {
  margin: 34px 0;
  background-color: #cccccc;
}

.main-text-wrapper h4 {
  font-size: 20px;
  font-weight: 500;
  margin-top: 36px;
  letter-spacing: 1px;
}

.main-text-wrapper h5 {
  font-size: 18px;
  font-weight: 500;
  color: #666666;
  margin-top: 16px;
  margin-left: 13px;
}

.main-text-wrapper p {
  font-size: 16px;
  font-weight: 400;
  width: 1040px;
}

.text-wrapper {
  margin-left: 40px;
  position: relative;
  display: block;
  /* display: flex;
    flex-direction: column; */
}

.card {
  width: 100%;
  min-height: 276px;
  border-radius: 15px;
  box-shadow: 3px 5px 15px #e7e0e0;
  position: relative;
  padding: 28px 29px 36px 38px;
  background-color: #fff;
  @media screen and (max-width: 768px) {
    padding: 14px 15px;
    width: calc(100% - 20px);
    margin: 0 auto;
  }
}
.card .category span {
  font-size: 14px;
  color: #666666;
}
.card .category span:nth-child(6) {
  font-size: 5px;
  display: inline-block;
  transform: translateY(-2px);
}
.card .category span:nth-child(4) {
  font-size: 5px;
  display: inline-block;
  transform: translateY(-2px);
}
.card .category span:nth-child(2) {
  padding: 0 4px;
}
.card .category span:nth-child(1) {
  font-weight: 700;
  color: #000;
}
.card h1 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.card-contents {
  width: calc(100%);
  min-height: 190px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.card-contents > button {
  align-self: flex-end;
}
.card-contents-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: calc(100% - 147px);
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

.card-contents p {
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  letter-spacing: 0.1px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.researcher span {
  font-size: 15px;
}
.researcher span:first-child {
  font-weight: 700;
  margin-right: 2px;
}
.researcher {
  padding-left: 9px;
}
.researcher span:nth-child(2) {
  margin-right: 2px;
}
.researcher span:last-child {
  color: #cccccc;
  letter-spacing: 0.5px;
}
.research-wrapper {
  /* margin-bottom: 18px; */
  gap: 19px;
  flex-wrap: wrap;
}
.hashtag-wrapper {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  padding: 10px 0;
}
.card-type2 .category {
  display: flex;
  gap: 9px;
}
.card-type2 .category::before {
  content: "";
  background-image: url("../../assets/img/main-text-before.png");
  background-size: contain;
  background-repeat: no-repeat;
  display: inline-block;
  flex-shrink: 0;
  width: 12px;
  height: 14px;
  transform: translateY(2px);
}
.card-type2 .card-contents {
  width: 100%;
  min-height: 150px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #cccccc;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}
.card-type2 .button-wrapper {
  gap: 5px;
  min-width: 169px;
  @media screen and (max-width: 768px) {
    flex-direction: row !important;
    padding-block-end: 10px;
    width: 100%;
  }
}
.card-type2 .button-wrapper button {
  height: 45px;
  @media screen and (max-width: 768px) {
    height: 30px;
    flex: 1;
    padding: 5px 10px;
  }
}
.card-type2 .hashtag-wrapper {
}
/* 25.11.21 추가 */
.icon{
    padding:0 20px;
    font-size: 15px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    @media screen and (max-width: 768px) {
      font-size: 12px;
    }
}
.icon::before{
    content:"";
    display: inline-block;
    width:22px;
    height:22px;
    background-repeat: no-repeat;
    @media screen and (max-width: 768px) {
      height: 17px;
      font-size: 12px;
    }
}
.research-wrapper-box {
  margin-top: 33px;
  gap: 108px;
  @media screen and (max-width: 768px) {
    gap: 10px;
    flex-direction: column;
  }
}
.research-wrapper {
  gap: 0px;
  border-left: 5px solid #cccccc;
}
.card-type2 .flex-column {
  display: flex;
  flex-direction: column;
  align-self: baseline;
}
.card-type2 .research-wrapper-box .research-wrapper {
  gap: 13px;
}

.text-wrapper span {
  padding: 10px 0px 0px 10px;
}

.text-wrapper::before {
  content: "";
  width: 5px;
  height: 100%;
  display: inline-block;
  /*background-color: #e3e3e3;*/
  position: absolute;
  border-radius: 5px;
  top: 10px;
  left: -4px;
}

.text-wrapper p {
  padding-left: 10px;
  margin-top: 10px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
}

.text-wrapper p span {
  display: block;
  font-size: 16px;
  font-weight: 600;
}

.text-wrapper span {
  padding: 0 !important;
}

.pdf-app .toolbar {
  z-index: 100 !important;
}

.pdf-app #toolbarContainer {
  height: 40px !important;
}

.pdf-app #toolbarViewer {
  padding-top: 7px !important;
}

.pdf-app #sidebarContainer {
  top: 40px !important;
}

.pdf-app #thumbnailView {
  width: 100% !important;
}

.pdf-app .toolbarField[type="checkbox"] {
  margin: 4px 0 !important;
}

.pdf-app .textLayer .highlight.selected {
  padding: 0px 0px 0px 0px !important;
}
</style>

<style scoped>
.text-wrapper {
  margin: 30px 0px 0px 0px;
}

.pdf-app.light {
  --pdf-toolbar-color: #000;
  --pdf-button-toggled-color: #000;
}
</style>
